/**
 * Prepend "https://" to a string
 */
export const prependHttps = (url) => {
    if (url === undefined || url === "") {
        return url;
    }
    if (url.match(/^http:\/\//i)) {
        return url.replace(/^http:\/\//i, "https://");
    }
    else if (!url.match(/^https:\/\//i)) {
        return `https://${url}`;
    }
    else {
        return url;
    }
};
//# sourceMappingURL=urls.js.map